export default __webpack_public_path__ + "static/media/detail2.c715c945.avif";